<template>
  <div class="bookingtable-component">
    <table class="table table-striped table-light table-hover">
      <thead class="thead-dark">
        <tr>
          <td>{{ $t('booking.roomscategorytable.tableheader.objId') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.code') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.description') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.minPax') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.maxPax') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.stdPax') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.extraBeds') }}</td>
          <td>{{ $t('booking.roomscategorytable.tableheader.price') }}</td>
          <td>&nbsp;</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(roomCategory, k) in this.$parent.allRoomCategories">
          <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.objId }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.objId" class="form-control"/></div>
					</td>
          <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.code }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.code" class="form-control"/></div>
					</td>
           <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.description }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.description" class="form-control"/></div>
					</td>
           <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.minPax }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.minPax" class="form-control"/></div>
					</td>
           <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.maxPax }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.maxPax" class="form-control"/></div>
					</td>
           <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.stdPax }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.stdPax" class="form-control"/></div>
					</td>
           <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.extraBeds }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.extraBeds" class="form-control"/></div>
					</td>
           <td>
						<div v-if="!roomCategory.editing" @dblclick="editRoomCategory(roomCategory)">{{ roomCategory.price }}</div>
						<div v-else="roomCategory.editing"><input type="text" @keyup.enter="editRoomCategory(roomCategory)" v-model="roomCategory.price" class="form-control"/></div>
					</td>
          <td>
            <div v-if="!roomCategory.editing">
							<button @click="editRoomCategory(roomCategory)" class="btn btn-secondary mr-2">{{ $t('booking.tablebuttons.edit') }}</button>
							<button @click="removeRoomCategory(k, roomCategory)" class="btn btn-danger">{{ $t('booking.tablebuttons.delete') }}</button>
						</div>
						<div v-if="roomCategory.editing">
							<button @click="endEditRoomCategory(roomCategory)" class="btn btn-success">{{ $t('booking.tablebuttons.ok') }}</button>
						</div>
          </td>
        </tr>
      </tbody>
      <tfoot>
				<tr>
					<td><input type="text" v-model="objId" class="form-control"/></td>
					<td><input type="text" v-model="code" class="form-control"/></td>
					<td><input type="text" v-model="description" class="form-control"/></td>
					<td><input type="text" v-model="minPax" class="form-control"/></td>
					<td><input type="text" v-model="maxPax" class="form-control"/></td>
					<td><input type="text" v-model="stdPax" class="form-control"/></td>
					<td><input type="text" v-model="extraBeds" class="form-control"/></td>
					<td><input type="text" v-model="price" class="form-control"/></td>
					<td>
						<button @click="addRoomCategory" class="btn btn-primary">{{ $t('booking.roomscategorytable.tableheader.saveallroomcategories') }}</button>
					</td>
				</tr>
			</tfoot>
    </table>
  </div>
</template>


<script>
import axios from "axios";
import Stringify from "vue-stringify";
import DatePicker from "vuejs-datepicker";
import moment from "moment";
import { mapState } from 'vuex';

export default {
  props: [],
  data: function() {
    return {
      lastItem: null,

      objId: null,
      code: null,
      description: null,
      minPax: null,
      maxPax: null,
      stdPax: null,
      extraBeds: null,
      price: null,
      edited: false

    };
  },
  computed: {
	...mapState('settings', ['config']),
	},
  mounted: function() {

  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  methods: {
    editRoomCategory(roomCategory) {
      	if (this.lastItem) {
					this.lastItem.editing = false;
				}
				this.lastItem = roomCategory;
				roomCategory.editing = true;
    },
    removeRoomCategory(k, roomCategory) {

    },
    endEditRoomCategory(roomCategory) {
				roomCategory.editing = false;
				this.saveAllRoomCategories();

    },
    addRoomCategory() {
      let roomCategory = {
					id: 'new',
          objId: this.objId,
					code: this.code,
					description: this.description,
					minPax: this.minPax,
					maxPax: this.maxPax,
					stdPax: this.stdPax,
					extraBeds: this.extraBeds,
					price: this.price,
					editing: false
				};
        this.$parent.allRoomCategories.push(roomCategory);

        this.objId = '';
        this.code = '';
        this.description = '';
        this.minPax = '';
        this.maxPax = '';
        this.stdPax = '';
        this.extraBeds = '';
        this.price = '';

        this.saveAllRoomCategories();
    },
    removeRoomCategory(k, roomCategory) {

      var isDelete = confirm("Sind Sie sicher (die Daten sind nach dem Löschen verloren) ?");
      if (isDelete) {
        let idx = this.$parent.allRoomCategories.indexOf(roomCategory);
        this.$parent.allRoomCategories.splice(idx, 1);

        let formData = new FormData();
        formData.append('roomCategoryToRemove', JSON.stringify(roomCategory));

        axios({
          method: 'post',
          url: this.config.apiUrl + 'removeRoomCategory',
          withCredentials: true,
          data: formData
        }).then(response => (true))

      }
    },

    saveAllRoomCategories() {

				let formData = new FormData();
				let roomCoategory = null;
				for (roomCoategory in this.$parent.allRoomCategories) {
					formData.append('allRoomCategories[]', JSON.stringify(this.$parent.allRoomCategories[roomCoategory]));
				}

				axios({
					method: 'post',
					url: this.config.apiUrl + 'saveAllRoomCategories',
          withCredentials: true,
					data: formData
				}).then(response => (this.$parent.getAllRoomCategories()))


      console.log("Save all room categories!!!");
    }

  },
  components: {
    DatePicker
  }
};
</script>

<style scoped lang="scss">
	.bookingtable-component table td {
		cursor: pointer;
		vertical-align: middle;
	}

	.bookingtable-component table thead th,
	.bookingtable-component table tbody td:last-child,
  .bookingtable-component table tfoot td:last-child {
		white-space: nowrap;
    text-align: right;
	}

	.bookingtable-component table thead td {
		background-color: #383639;
		color: #fff;
		font-family: 'BrandonGrotesque-Bold';
		border-top: 1px solid #383639;
	}

	.bookingtable-component table tfoot td {
		background-color: #d5d5d6;
	}

	.bookingtable-component .btn {
		border-radius: 0;
	}
</style>

<style lang="scss">
	body {
		overflow: auto;
	}

	.bookingtable-component .form-control {
		font-size: 1rem;
		padding: .125rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		background: #fff;
		letter-spacing: 0;
	}

	.bookingtable-component .form-control:hover,
	.bookingtable-component .form-control:focus,
	.bookingtable-component .form-control:active {
		background: #fff;
	}
</style>
